<app-courses-header
  [course]="course()"
  (navigate)="scrollToSection($event)"
></app-courses-header>

<div class="bg-gray-50">
  @if (course(); as course) {
    <section
      class="max-w-screen-xl mx-auto px-4 relative z-10 pt-10 pb-14 grid md:grid-cols-2 gap-4"
    >
      <div class="contents md:flex md:flex-col md:gap-4">
        <div
          class="bg-white shadow-md shadow-gray-200 rounded p-5 flex items-center justify-center order-1"
        >
          <img
            class="w-full rounded"
            [alt]="course.theme.name"
            [src]="course.theme.thumbnail ?? '/assets/img/hero-temp.png'"
          />
        </div>

        <div class="order-3">
          @if (course.camp.sleepover) {
            <app-overnight-course-practical-exposition></app-overnight-course-practical-exposition>
          } @else {
            <app-regular-course-practical-exposition></app-regular-course-practical-exposition>
          }
        </div>

        <div class="order-4">
          @if (course.camp.sleepover) {
            <app-overnight-course-included-exposition></app-overnight-course-included-exposition>
          } @else {
            <app-regular-course-included-exposition></app-regular-course-included-exposition>
          }
        </div>

        <div class="order-5">
          <app-course-catalogue-details-card id="faq" i18n-label label="FAQ">
            <mat-accordion>
              @for (faq of faqEntries; track $index) {
                <app-faq-entry [entry]="faq"></app-faq-entry>
              }
            </mat-accordion>
            <a
              routerLink="/faq"
              i18n
              class="button w-full flex justify-center mt-4"
            >
              Full FAQ
            </a>
          </app-course-catalogue-details-card>
        </div>
      </div>

      <div class="contents md:flex md:flex-col md:gap-4">
        <div class="order-2">
          <app-course-catalogue-details-card [label]="label()">
            <p class="mb-4">{{ course.theme.description }}</p>
            <div class="has-[p]:mb-4">
              @for (item of conditionalText(); track $index) {
                <p>
                  {{ item }}
                </p>
              }
            </div>
            <div class="flex justify-between items-end">
              <div class="flex flex-wrap flex-col gap-3">
                <div class="flex items-center gap-2 text-gray-600">
                  <mat-icon class="">map</mat-icon>
                  <div class="flex flex-col">
                    <span class="text-base font-bold" i18n>Location</span>
                    <span class="text-sm">
                      {{ course.locationName }}
                    </span>
                  </div>
                </div>
                <div class="flex items-center gap-2 text-gray-600">
                  <mat-icon class="">calendar_today</mat-icon>
                  <div class="flex flex-col">
                    <span class="text-base font-bold" i18n>Period</span>
                    <span class="text-sm">{{ period() }}</span>
                  </div>
                </div>
                <div class="flex items-center gap-2 text-gray-600">
                  <mat-icon class="">face</mat-icon>
                  <div class="flex flex-col">
                    <span class="text-base font-bold" i18n>Age</span>
                    <span class="text-sm">{{ course | ages }}</span>
                  </div>
                </div>
              </div>
              <p class="text-primary">
                <span class="text-2xl mr-1">
                  {{ course.price | currency: "EUR" : "symbol" : "1.0-0" }}
                </span>
                <span class="text-sm" i18n>per child</span>
              </p>
            </div>

            <button
              class="button w-full mt-4 flex justify-center"
              [matTooltip]="tooltipText()"
              [i18nRouterLink]="['/cart/add/course', course.id]"
              [disabled]="!isCourseAvailable()"
              i18n
            >
              Enroll
            </button>
          </app-course-catalogue-details-card>
        </div>

        <div class="order-6">
          <app-course-catalogue-details-card i18n-label label="Share this camp">
            <app-frontend-share-socials></app-frontend-share-socials>
          </app-course-catalogue-details-card>
        </div>
      </div>
    </section>
  }
</div>
